import { useT } from "@transifex/react";
import type { CatalogBook } from "../../../helpers/BookCatalog";
import BookGrid from "./BookGrid";
import BookSelectionStepHeading from "./BookSelectionStepHeading";

interface BookStepProps {
    languageName: string;
    /** Which books the chosen federal state lets through. */
    approvalHint: string;
    books: Array<CatalogBook>;
    selectedBookId?: string;
    onPick: (book: CatalogBook) => void;
}

const BookStep = (props: BookStepProps) => {
    const t = useT();
    const t_title = t("Textbooks for {language}", { _tags: "CreateTest,SelectBook", language: props.languageName });

    return (
        <div className="flex flex-col gap-s">
            <BookSelectionStepHeading
                title={t_title}
                hint={props.approvalHint}
            />
            <BookGrid
                books={props.books}
                selectedBookId={props.selectedBookId}
                onPick={props.onPick}
            />
        </div>
    );
};

export default BookStep;
